import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { UtilsService } from 'src/app/common';
import { emit } from 'process';

export interface ActionButton {
    id?: string;
    label: string;
    type: string;
    class?: string;
    htmlType?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
    icon?: string;
    iconPos?: 'left' | 'right';
    outlined?: boolean;
    color?: 'primary-ig' | 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help';
    size?: 'xsmall' | 'small' | 'medium' | 'normal' | 'large' | 'xlarge' | 'full';
}

@Component({
    selector: 'gig-action-button',
    standalone: true,
    imports: [CommonModule, ButtonModule],
    templateUrl: './action-buttons.component.html',
    styleUrls: ['./action-buttons.component.scss']
})
export class ActionButtonsComponent {

    private util = inject(UtilsService);

    @Input() buttons: ActionButton[] = [];
    @Input() alignment: 'left' | 'center' | 'right' | 'space-between' = 'space-between';
    @Input() customClass: string = '';

    @Output() buttonClick = new EventEmitter<{}>();

    onButtonClick(button): void {
        this.util.logger.info('Action button clicked, type:', button.type);
        this.buttonClick.emit({type: button.type});
    }

    getButtonClass(button: ActionButton): string {
        const classes: string[] = ['btn'];

        if (button.outlined) {
            classes.push('btn-outlined');
        }

        const color = button.color || this.mapTypeToColor(button.type);

        // this.util.logger.info(button);

        switch (color) {
            case 'primary-ig':
                classes.push('btn-primary-ig');
                break;
            case 'primary':
                classes.push('btn-primary');
                break;
            case 'secondary':
                classes.push('btn-secondary');
                break;
            case 'success':
                classes.push('btn-success');
                break;
            case 'info':
                classes.push('btn-info');
                break;
            case 'warning':
                classes.push('btn-warning');
                break;
            case 'danger':
                classes.push('btn-danger');
                break;
            case 'help':
                classes.push('btn-help');
                break;
            default:
                classes.push('btn-primary');
                break;
        }

        if (button.class) {
            classes.push(button.class);
        }

        return classes.join(' ');
    }

    private mapTypeToColor(type: string): string {
        switch (type) {
            case 'delete':
                return 'danger';
            case 'confirm':
                return 'success';
            case 'warning':
                return 'warning';
            case 'cancel':
                return 'secondary';
            default:
                return 'primary';
        }
    }
}
